'use client'

import { memo } from 'react'
import type { NotificationListItem } from '@/lib/api/notification'
import { InteractionNotificationCard } from './InteractionNotificationCard'
import { PersonalNotificationCard } from './PersonalNotificationCard'
import { SystemNotificationCard } from './SystemNotificationCard'
import type { NotificationVariant } from './styles'

export type NotificationItemProps = {
  variant: NotificationVariant
  item: NotificationListItem
  onClick: (item: NotificationListItem) => void
  onActorClick: (item: NotificationListItem) => void
  onNpcClick: (item: NotificationListItem) => void
}

function renderByTab({ variant, item, onClick, onActorClick, onNpcClick }: NotificationItemProps) {
  const handleClick = () => onClick(item)
  if (item.tab === 3) {
    return (
      <InteractionNotificationCard
        variant={variant}
        item={item}
        onActorClick={() => onActorClick(item)}
        onNpcClick={() => onNpcClick(item)}
      />
    )
  }
  if (item.tab === 2) {
    return <PersonalNotificationCard variant={variant} item={item} onClick={handleClick} />
  }
  return <SystemNotificationCard variant={variant} item={item} onClick={handleClick} />
}

/** Routes each list item to the tab-specific card. */
function NotificationItemComponent(props: NotificationItemProps) {
  return renderByTab(props)
}

export const NotificationItem = memo(NotificationItemComponent)
